import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromAccount from './reducers/account.reducer';
import {EffectsModule} from '@ngrx/effects';
import {AccountEffects} from './effects/account.effects';
import * as fromAuthority from './reducers/authority.reducer';
import * as fromAccountMgtListFilter from './reducers/account-mgt-list-filter.reducer';
import { AccountMgtListFilterEffects } from './effects/account-mgt-list-filter.effects';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    EffectsModule.forFeature([ AccountEffects, AccountMgtListFilterEffects ]),
    StoreModule.forFeature('account', fromAccount.reducer),
    StoreModule.forFeature('authority', fromAuthority.reducer),
    StoreModule.forFeature('accountMgtListFilter', fromAccountMgtListFilter.reducer),
    StoreModule.forFeature('accountListFilter', fromAccount.AccountFilterreducer)
  ]
})
export class AccountModule { }
